import * as React from "react";
import { Stack, Typography, Paper } from "@mui/material";

export default function PricingPage() {
    return (
        <Stack spacing={2}>
            <Typography variant="h5" sx={{ fontWeight: 1000 }}>Season Pricing</Typography>
            <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3 }}>
                <Typography color="text.secondary">
                    Coming next: "μία τιμή → μήνες" rules UI
                </Typography>
            </Paper>
        </Stack>
    );
}
